import { formatYearMonthTag } from '~/Date';
var TimePeriodGenerator = /** @class */ (function () {
    function TimePeriodGenerator() {
    }
    Object.defineProperty(TimePeriodGenerator.prototype, "currentMonth", {
        get: function () {
            var date = new Date();
            var from = formatYearMonthTag(date);
            return [from, from];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimePeriodGenerator.prototype, "currentQuarter", {
        get: function () {
            var date = new Date();
            var currentQuarter = Math.trunc(date.getMonth() / 3);
            date.setMonth(currentQuarter * 3);
            var from = formatYearMonthTag(date);
            date.setMonth(date.getMonth() + 2);
            var to = formatYearMonthTag(date);
            return [from, to];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimePeriodGenerator.prototype, "currentYear", {
        get: function () {
            var date = new Date();
            date.setMonth(0);
            var from = formatYearMonthTag(date);
            date.setMonth(11);
            var to = formatYearMonthTag(date);
            return [from, to];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimePeriodGenerator.prototype, "previous12Months", {
        get: function () {
            var date = new Date();
            var to = formatYearMonthTag(date);
            date.setMonth(date.getMonth() - 11);
            var from = formatYearMonthTag(date);
            return [from, to];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimePeriodGenerator.prototype, "previous4Quarters", {
        get: function () {
            var date = new Date();
            var currentQuarter = Math.trunc(date.getMonth() / 3);
            date.setMonth(currentQuarter * 3 - 9);
            var from = formatYearMonthTag(date);
            date.setMonth(date.getMonth() + 11);
            var to = formatYearMonthTag(date);
            return [from, to];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimePeriodGenerator.prototype, "previousMonth", {
        get: function () {
            var date = new Date();
            date.setMonth(date.getMonth() - 1);
            var from = formatYearMonthTag(date);
            return [from, from];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimePeriodGenerator.prototype, "previousQuarter", {
        get: function () {
            var date = new Date();
            var previousQuarter = Math.trunc(date.getMonth() / 3) - 1;
            date.setMonth(previousQuarter * 3);
            var from = formatYearMonthTag(date);
            date.setMonth(date.getMonth() + 2);
            var to = formatYearMonthTag(date);
            return [from, to];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimePeriodGenerator.prototype, "previousYear", {
        get: function () {
            var date = new Date();
            date.setFullYear(date.getFullYear() - 1);
            date.setMonth(0);
            var from = formatYearMonthTag(date);
            date.setMonth(11);
            var to = formatYearMonthTag(date);
            return [from, to];
        },
        enumerable: false,
        configurable: true
    });
    return TimePeriodGenerator;
}());
export { TimePeriodGenerator };
